module.exports = __webpack_public_path__ + "img/02.d757d387.png";